import { useTranslation } from 'react-i18next';
import LoadingSpinner from '../components/lib/UI/loadingSpinner/LoadingSpinner';
import { useAppSelector } from 'setup/store';
import ErrorBox from 'components/lib/error-box';
import { useParams } from 'react-router-dom';
import UserDataForm from 'components/user/user-data-form/UserDataForm';
import { Box } from '@mui/material';
import StoreDataForm from 'components/store/store-data-form/StoreDataForm';

const AddStorePage = () => {
  const { t } = useTranslation();

  const error = useAppSelector((store) => store.userReducer.error);

  return (
    <section style={{ marginBottom: '80px' }}>
      <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} gap={2} className="pageTitleTitleContainer">
        <h2 className="pageTitle">{t('page.addNewStore')}</h2>
      </Box>
      {error ? <ErrorBox title="Error" message={error.msg} /> : null}
      <StoreDataForm storeId={undefined} addNew />
    </section>
  );
};

export default AddStorePage;
